import { Component, OnDestroy, OnInit } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TimestampFormatPipe } from '../commons/timestampFormatPipe';
import { ComponentCacheService } from '../services/component-cache.service';
import { NavigatorService } from '../services/navigator.service';
import { RisorsaAziendaleService } from '../services/risorsa-aziendale/risorsa-aziendale.service';
import { ResponseQueryByCriteria } from '../shared/dto/responseQueryByCriteria';
import { RisorsaAziendaleDTO } from '../shared/dto/risorsa-aziendale/risorsa-aziendale';
import { GenericListComponent } from '../shared/GenericListCoumponent';

@Component({
  selector: 'app-risorsa-aziendale',
  templateUrl: './risorsa-aziendale.component.html',
  styleUrls: ['./risorsa-aziendale.component.scss']
})
export class RisorsaAziendaleComponent extends GenericListComponent implements OnInit, OnDestroy  {

  constructor(
    private risorsaAziendaleService:  RisorsaAziendaleService,
    componentCacheService: ComponentCacheService,
    navigatorService: NavigatorService,
    dateAdapter: DateAdapter<Date>,
    router: Router,
    snackBar: MatSnackBar,
    timestampFormatPipe: TimestampFormatPipe
  ) {
    super(
      navigatorService,
      componentCacheService,
      dateAdapter,
      router,
      snackBar,
      timestampFormatPipe);
    this.displayedColumns = ['id', 'gruppo', 'url',  'icona', 'descrizione', 'detail'];
    this.parameters = {
      dataSource: [],
      showList: false,
      filter: null,
      filterSede: null,
      sortField: null,
      sortDirection: null,
      pageNumber: 0,
      pageSize: 50,
      length: 0
    }
  }

  list() {
    this.risorsaAziendaleService.risorsaAziendaleList(
      this.parameters.pageNumber,
      this.parameters.pageSize,
      this.parameters.sortDirection,
      this.parameters.sortField,
      this.parameters.descrizione,
      this.parameters.gruppo).subscribe(
        (res: ResponseQueryByCriteria<RisorsaAziendaleDTO>) => {
          console.log("response : " + res);
          this.parameters.dataSource = res.content;
          this.parameters.pageNumber = res.pageNumber;
          this.parameters.length = res.totalElements;
          this.parameters.showList = true;
        }
      )
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

}
